module.exports = __webpack_public_path__ + "media/images/icon-stats-company-969597c01dbf186ec2184131e5e36ca2.svg";